import { render, staticRenderFns } from "./Cadastro.vue?vue&type=template&id=2d3cf682&"
import script from "./Cadastro.vue?vue&type=script&lang=js&"
export * from "./Cadastro.vue?vue&type=script&lang=js&"
import style0 from "./Cadastro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports